import { MultipleChoiceProxyVoteItem } from "./MultipleChoiceProxyVoteItem";

export default MultipleChoiceProxyVoteItem;